import React, { useState } from 'react';
import { MEDITATION_GUIDE } from '../../Datasets/MeditationGuides'
import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent, CardMedia, Container, Grid, List, ListItem, ListItemText, TextField, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import styles from './MeditationGuide.module.css';
import SearchIcon from '@mui/icons-material/Search';



const MeditationTechnique = ({ technique }) => {
  return (
    <Card style={{ marginBottom: '20px', padding:"1rem" }}>
      <Typography variant="h5" component="div" sx={{ backgroundColor: "#003f03", color: "white", textAlign: "center" }}>
          {technique.Title}
        </Typography>
      <div style={{ maxHeight: "400px", overflowY: "scroll" }}>
        <CardMedia
          component="img"
          height="194"
          image={technique.link}
          alt={technique.Title}
        />
      <CardContent>
        <Typography variant="body2" color="textSecondary">
          {technique.Description}
        </Typography>
      </CardContent>
      <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />} sx={{ backgroundColor: "#c1fcc9" }}>
            <Typography variant="h6">Steps</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List>
            {technique.Steps.map((step, index) => (
              <ListItem key={index}>
                <ListItemText primary={step} />
              </ListItem>
            ))}
          </List>
        </AccordionDetails>
      </Accordion>
      <CardContent>
        <Typography variant="h6">Benefits</Typography>
        <Typography variant="body2">{technique.Benefits}</Typography>
        <Typography variant="h6">Age Group Suggested</Typography>
        <Typography variant="body2">{technique['Age Group Suggested']}</Typography>
        <Typography variant="h6">Helpful in</Typography>
        <Typography variant="body2">{technique['Helpful in']}</Typography>
        <Typography variant="h6">Who Should Avoid</Typography>
        <Typography variant="body2">{technique['Who Should Avoid']}</Typography>
      </CardContent>
      </div>
    </Card>
  );
};

function MeditationGuide() {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredMeditationData = MEDITATION_GUIDE.filter((technique) =>
    technique.Title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container className={styles.container} sx={{ padding: "0 !important", maxWidth: "100% !important" }}>
      <div className={styles.searchMenu}>
        <h1>Meditation Guides</h1>
        <TextField
          label="Search"
          variant="outlined"
          fullWidth
          margin="normal"
          value={searchTerm}
          color='success'
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <SearchIcon sx={{ color: 'action.disabled' }} />
            ),
          }}
        />
      </div>

      <Grid container spacing={3}>
        {filteredMeditationData.map((technique, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <MeditationTechnique technique={technique} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default MeditationGuide;
